import { useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import AllBlogs from "../../config/blogs.json";
import "./blogs.css";
import BlogLanding from "./BlogLanding";
import { Link } from "react-router-dom";
import { frmatDateMonth, linkToBlog } from "../../utils/utils";
function Blog(props) {
  const [currentBlog, setCurrentBlog] = useState({});
  console.log("currentBlog: ", currentBlog);
  const [htmlPara, setHtmlPara] = useState("");

  const htmlcontent = `While oats have made it to our breakfast tables in no time due to their specific benefits for our bodies, there is still something that you might have missed out on when it comes to oats. I am talking about colloidal oatmeal! Has dry, itchy skin shaken your faith? Now, you do not need to give up on your dry, itchy skin, just not yet. Colloidal oatmeal might prove to be the ingredient that shoos away your discomfort.

Although the ingredient might sound familiar, chances are you are as much in the dark about colloidal oatmeal as someone who has not heard of it. If you have been treating your dry, flaky, itchy skin for some time, your products will likely contain this superfood ingredient. Colloidal oatmeal is loaded with nutrients(but obvious), lipids, saponins, and antioxidants, and this makes colloidal oatmeal a protector, soother, nourisher, cleanser, and moisturizer.

Colloidal oatmeal has been around for centuries relieving itching and irritation. The soothing superfood has some real skin-treating powers. It not only soothes dry skin by locking in moisture but also forms a protective film on your skin when combined with water or oil.

Formed from very wholesome grain, oats, colloidal oatmeal has been effectively helpful with eczema and other dry, sensitive skin conditions by forming a barrier when your skin is unable to do so. The ingredient is worth treasuring since it also helps treat acne by soaking up the extra oil, and the saponins in oats exfoliate your skin gently.

The instant beauty staple is everything you ever needed to relieve that itch, but hold on. Take a step back and know the essentials before stocking up on this. 
<p><b>How does this powerhouse protein generator benefit your skin?</b></p>
<p>The list is long, so brace yourselves!</p>

<ul>
  <li><b>Strengthening your skin barrier</b><br>
  The wall that stands between bacteria, UV rays, pollution, etc., and your delicate skin: your skin barrier gets weakened or damaged. The amping up of skin cells by peptides helps improve your skin barrier. Apart from the skin barrier, peptides help your skin strengthen in general by strengthening the proteins and connective tissues in the dermis. These amped-up strengthening proteins like keratin, elastin, and collagen help your skin recover from any injury and strengthen and maintain its structure.</li>

  <li><b>The Masterstroke- Collagen boost</b><br>
  The protein that we all after, the protein that makes any skincare enthusiast rave, collagen. Collagen enables your skin to look young and fresh. This is the protein that makes your skin tight, firm, and resilient. We all need a little more collagen in our lives, and we go to great lengths for it. And peptides shorten those lengths through their short amino acid chains that reach the depths of your skin and trigger collagen. Peptides not only stimulate and renew collagen but also decrease its breakdown. So, now you know why peptides have been the craze; they maintain your young, healthy, and beautiful skin.</li>

  <li><b>Anti-aging star for a reason</b><br>
  Peptides are known for their anti-aging abilities, all thanks to the collagen boost. Collagen makes your skin firm and plump, leaving no room for wrinkles and fine lines. Rebuilding collagen preserves your skin's youthfulness.</li>

  <li><b>Ease up the inflammation</b><br>
  The anti-inflammatory properties of peptides are due to the presence of antioxidants. They repair, calm, and soothe damaged skin.</li>

  <li><b>Will fight acne</b><br>
  Antimicrobial peptides kill acne-causing bacteria, combating breakouts.</li>

  <li><b>Lock in the Hydration</b><br>
  The reduction of collagen also leads to dehydration, as the structure is too weak to hold in the water. So when you boost your collagen production with peptides, Hydration is a much-needed bonus. Moreover, peptides are smart and serve your skin where there is a need. If the peptides you applied make your skin dehydrated, it will reassemble itself to hydrate it by producing more water-retaining cells and proteins. What is even more amazing is that peptides also increase hyaluronic acid production, the ultra-hydrating substance.</li>

  <li><b>Firmer the skin, the younger it feels</b><br>
  Among the several anti-aging features peptides come with, firm and more elastic skin is one. Peptides keep your skin from going saggy and keep it intact by boosting essential proteins' production, elastin being one of them. They maintain the shape of your skin, making it firmer and tauter.</li>

  <li><b>Soft to touch skin</b><br>
  Peptides improve your skin's texture inflicted with roughness, dryness, discoloration, etc., by UV exposure. Peptides also heal your skin, and the collagen makes your skin clear, even, and bouncy!</li>
</ul>

<p><b>How exactly do these peptides function in your skincare?</b></p>
<p>Peptides penetrate deeply and send signals to the cells asking them to produce collagen and elastin. The right peptide will target the specific cells and reap the benefits that you are after.</p>

<p>When it comes to the cosmetic arena, the peptides are bifurcated into three broad groups:</p>

<ul>
  <li><b>Signal peptides</b> - The name says it all. These are peptides that send messages to different parts of your skin to promote proteins.</li>
  <li><b>Carrier peptides</b> - The peptides that transport minerals in the skin, such as copper, boost collagen.</li>
  <li><b>Neurotransmitter peptides</b> - The ones that block those chemicals from releasing that lead to fine lines. These are the peptides that smooth out wrinkles.</li>
</ul>

<p>To understand the peptides products you are buying, the following list will help:</p>

<ul>
  <li><b>Copper peptides</b><br>
  Copper peptides moisturize skin by remaining on its surface.</li>
  
  <li><b>Matrixyl 3000</b><br>
  The peptides will repair collagen proteins in the skin and improve aging signs: fine lines, photoaging, wrinkles. The multi-peptide serum by Minimalist has 7% matrixyl 3000, and it works exceptionally to smoothen wrinkles, boost moisturization, and increase elasticity in four weeks.</li>
  
  <li><b>Argireline</b><br>
  Anti Aging peptide restores the firmness in the skin and prevents sagging.</li>
  
  <li><b>Palmitoyl tripeptides</b><br>
  Anti-inflammatory peptides hydrate the skin and reduce fine lines, wrinkles, and skin damage by the sun and pollution.</li>
  
  <li><b>Tetrapeptides</b><br>
  Increases skin elasticity, evens out skin tone, reduces discoloration caused by sun, wounds, acne, etc.</li>
</ul>

<p><b>What claims are legit and which are not? What does the research say about peptides?</b></p>
<p>The last 20 years have seen a significant growth of peptides in the anti-aging arena.</p>

<p>A 2008 study used a hydrolyzed keratin peptide and performed vivo long-term studies to evaluate the water barrier function of the skin and determine the elasticity and hydration of the skin. Measurements pointed out that keratin peptides strengthen the skin barrier, improving the skin's ability to hold water.</p>

<p>A recent 2020 open-label study examined women aged less than or equal to 40 years with visibly photoaged skin after applying a serum with l-ascorbic acid USP (15% w/v), tocopheryl acetate USP, and five ppm palmitoyl tripeptide-38 daily for 56 days. The result is that the serum with antioxidants and matrix-restoring peptides improves skin tone, decreases redness and roughness, and improves radiance, complexion, and wrinkles.</p>

<p>A double-blind clinical study conducted in 2004 evaluated the effect of hexapeptides on wrinkles by examining 20 healthy women from age 40 to 62. They applied 3% of peptide + 1% of booster molecule gel for four weeks and saw a reduction in the length, depth, and the total surface the wrinkles covered. The study shows that the collagen-like peptide works deeply and intensely on wrinkles.</p>
`;

  useEffect(() => {
    if (window.location.href.includes("/blogs/")) {
      const blogName = window.location.pathname
        .split("/")[3]
        ?.split("-")
        .join(" ");
      const blog = AllBlogs.blogs.filter(
        (item) => item.headline.toLowerCase() === blogName
      );
      setCurrentBlog(blog[0]);
      console.log("blog: ", blog);

      //   setSelectedProduct(blog);
    }
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.getElementById("para_blog").innerHTML.split("");

    //
    const firstLetter = htmlcontent.match(/./)[0]; // Extracting the first letter
    const modifiedContent = htmlcontent.replace(
      firstLetter,
      `<span class="first_letter_big">${firstLetter}</span>`
    );

    setHtmlPara(modifiedContent);
    console.log("modifiedContent: ", modifiedContent);
  }, []);
  return (
    <Row className="blog_page_genric">
      <Col md="8" className="para_wrapper_blogs">
        <p className="para_blog_subtitle">{currentBlog.subtitle}</p>
        <h1>{currentBlog.headline}</h1>

        <hr className="footer_hr" />
        <Row className="justify-content-center">
          <div className="blog_img_wrapper">
            <img src={currentBlog.image_url} alt="blog" />
          </div>
          <Col md="10">
            <div
              className="para_wrapper_blog"
              id="para_blog"
              dangerouslySetInnerHTML={{ __html: htmlPara }}
            />
          </Col>
        </Row>
      </Col>
      <Row className="related_blog_wrapper">
        <Col md="10" className="para_wrapper_related_blog">
          <h1>Related Posts</h1>
        </Col>
        {AllBlogs.blogs.map((blog) => {
          return (
            <>
              {currentBlog.headline !== blog.headline && (
                <Col md="4" className="blog_article_list" key={blog.subtitle}>
                  <div
                    className="link_product"
                    onClick={() => {
                      window.open(`${linkToBlog(blog)}`, "_self");
                    }}
                  >
                    <div className="blogs_card">
                      <div className="related_blog_img_wrapper">
                        <img src={blog.image_url} alt="blog" />
                      </div>
                      <div className="blog_card_info">
                        <p className="blog_card_headline">{blog.headline}</p>
                        <p className="blog_card_date">
                          {frmatDateMonth(blog.published_date)}
                        </p>
                      </div>
                    </div>
                  </div>
                </Col>
              )}
            </>
          );
        })}
      </Row>
    </Row>
  );
}

export default Blog;
